import React, { useContext } from 'react'
import { ModalContext } from '../../contexts/ModalContext.js';
import './eventmodal.scss';

const EventModal = () => {

	const { setIsEventModalOpen } = useContext(ModalContext)

	return (
		<div className="event-modal">
			<div className='event-modal-content'>
				<p>test</p>
				{/* <p className='event-button' onClick={(e) => {setIsEventModalOpen(false); e.preventDefault()}}>Verstanden</p> */}
			</div>
		</div>
	)
}

export default EventModal;